import { getSpotMinimumPrice } from "@/composables/useSpotMinimumPrice";
import { useProductionStrategyStore } from "@/dashboard/production_strategy/useProductionStrategyStore";
import { computed, type ComputedRef } from "vue";

export interface SpotStrategy {
  type: "market" | "minimum";
  minimumPrice?: number;
  durationMonths?: number;
}

/**
 * Composable for determining the initial spot strategy based on company portfolios
 *
 * @throws {Error} When company data is invalid
 */
export function useCompanySpotStrategy(): ComputedRef<SpotStrategy> {
  const productionStore = useProductionStrategyStore();

  return computed(() => {
    const minPrice = getSpotMinimumPrice(productionStore.portfolios);

    if (minPrice > 0) {
      // Find the SPOT_MIN_PRICE portfolio to get duration
      const minPricePortfolio = productionStore.portfolios.find(
        (p) => p.portfolio_type === "SPOT_MIN_PRICE"
      );

      const durationMonths = minPricePortfolio?.portfolio_instructions
        ?.duration_from_issuance
        ? productionStore.getDurationMonthsForCompany(
            minPricePortfolio.company_id
          )
        : 6;

      return {
        type: "minimum",
        minimumPrice: minPrice,
        durationMonths,
      };
    }

    return { type: "market" };
  });
}
